import { Accordion } from '@mantine/core'
import React from 'react'

import { colors } from '@flecto/ui/lib/theme'
import { DayOfWeek } from '@flecto/utils/src/Date/ScheduleHours'

import { useFormContext } from '../AddressForm'
import { AccordionControl } from './AccordionControl'
import { AccordionHours } from './AccordionHours'
import { BusinessHourProvider } from './BusinessHoursProvider'
import { type RangeEmitterData } from './HoursValidation'

export function BusinessSchedule() {
  const form = useFormContext()
  const [value, setValue] = React.useState<string[]>([])

  const accordionStyles = {
    item: {
      backgroundColor: 'white',
      border: `1px solid ${colors.neutral200}`,
    },
  }

  const onChangeTime = ({ payload }: RangeEmitterData) => {
    const oldData = form.getInputProps('operating_hours_schedule').value
    const newData = { ...oldData, ...payload }

    form.setFieldValue('operating_hours_schedule', newData)
  }

  return (
    <Accordion
      mt='md'
      chevronPosition='right'
      variant='separated'
      styles={accordionStyles}
      multiple
      value={value}
      onChange={setValue}
    >
      {[
        DayOfWeek.Monday,
        DayOfWeek.Tuesday,
        DayOfWeek.Wednesday,
        DayOfWeek.Thursday,
        DayOfWeek.Friday,
        DayOfWeek.Saturday,
        DayOfWeek.Sunday,
      ].map((day) => (
        <Accordion.Item value={day} key={day} id={`accordion-${day}`} px='lg' py='sm'>
          <BusinessHourProvider dayOfWeek={day} onChange={onChangeTime}>
            <AccordionControl isOpened={value.includes(day)} day={day} />
            <AccordionHours />
          </BusinessHourProvider>
        </Accordion.Item>
      ))}
    </Accordion>
  )
}
